var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],staticClass:"m-vue-pdf"}),_c('div',{staticStyle:{"width":"100vw","padding":"56px 0"}},[_c('img',{staticStyle:{"width":"100vw"},attrs:{"src":_vm.pdfUrl,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }